import { oc } from "@orpc/contract";
import { z } from "zod";

const UUIDSchema = z.uuid();

export const ContactTagSchema = z.object({
  id: UUIDSchema,
  name: z.string(),
});

export const ContactCompanySchema = z.object({
  id: UUIDSchema,
  name: z.string(),
});

export const ContactListItemSchema = z.object({
  id: UUIDSchema,
  name: z.string(),
  email: z.string().nullable(),
  phone: z.string().nullable(),
  title: z.string().nullable(),
  isPrimary: z.boolean(),
  company: ContactCompanySchema.nullable(),
  tags: z.array(ContactTagSchema),
  metadata: z.record(z.string(), z.unknown()).nullable(),
});

export const ContactsListPageInfoSchema = z.object({
  currentPage: z.int().positive(),
  totalPages: z.int().nonnegative(),
  totalCount: z.int().nonnegative(),
  hasNextPage: z.boolean(),
  hasPreviousPage: z.boolean(),
});

export const ContactsListSortColumnSchema = z.enum([
  "name",
  "email",
  "phone",
  "title",
  "isPrimary",
  "companyName",
  "createdAt",
]);

export const ListContactsInputSchema = z.object({
  page: z.int().min(1).optional(),
  pageSize: z.int().min(1).max(200).optional(),
  search: z.string().optional(),
  companyId: UUIDSchema.optional(),
  sortBy: ContactsListSortColumnSchema.optional(),
  sortDirection: z.enum(["asc", "desc"]).optional(),
});

export const ListContactsOutputSchema = z.object({
  contacts: z.array(ContactListItemSchema),
  pageInfo: ContactsListPageInfoSchema,
});

export const contactsContracts = {
  list: oc
    .input(ListContactsInputSchema)
    .output(ListContactsOutputSchema)
    .route({ method: "GET" }),
} as const;

export type ContactListItem = z.infer<typeof ContactListItemSchema>;
export type ListContactsInput = z.infer<typeof ListContactsInputSchema>;
export type ListContactsOutput = z.infer<typeof ListContactsOutputSchema>;
export type ContactsListSortColumn = z.infer<
  typeof ContactsListSortColumnSchema
>;
